import { render } from "./Router.vue?vue&type=template&id=295880fe"
import script from "./Router.vue?vue&type=script&lang=js"
export * from "./Router.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\alida\\Desktop\\jupyto\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__